import { toast } from "react-toastify";
import axios from "../../../service/axios";


export async function updateBin(binId, payload) {
    try {
        const res = await axios.put(`/locations/rack/${payload.rackId}/locations/${binId}/update`, payload)
        toast.success("Bin updated successfully");
        return res;
    } catch (error) {
        console.error("Update Bin Error:", error);
        throw error;
    }
}

export async function updateSubarea(subareaId, payload) {
    try {
        const res = await axios.put(`/locations/area/${payload.areaId}/locations/${subareaId}/update`, payload)
        toast.success("Subarea updated successfully");
        return res;
    } catch (error) {
        console.error("Update Subarea Error:", error);
        throw error;
    }
}
